module.exports = __webpack_public_path__ + "img/partner-2.e4ef15fa.png";